import { publicApi } from './api'

export async function getEventoPublico(slug) {
  const { data } = await publicApi.get(`/pub/eventos/${slug}`)
  return data.evento
}

export async function criarInscricao(payload) {
  const { data } = await publicApi.post('/pub/inscricoes', payload)
  return data
}

export async function getCheckout(inscricaoId) {
  const { data } = await publicApi.get(`/pub/checkout/${inscricaoId}`)
  return data
}

export async function getCheckoutStatus(inscricaoId) {
  const { data } = await publicApi.get(`/pub/checkout/${inscricaoId}/status`)
  return data
}

export async function getSucesso(inscricaoId) {
  const { data } = await publicApi.get(`/pub/sucesso/${inscricaoId}`)
  return data.inscricao
}

export async function validarCupom(payload) {
  const { data } = await publicApi.post('/pub/cupons/validar', payload)
  return data
}
